import React from "react";

const WhyInvestEtf4 = ({ ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            {...rest}
        >
            <rect opacity="0.2" x="4.25" y="5" width="44" height="44" fill="#6B929C" />
            <rect x="1" y="1" width="44" height="44" stroke="#6B929C" strokeWidth="2" />
            <path
                d="M31.443 26.5659C30.8599 27.945 29.9478 29.1602 28.7864 30.1054C27.6251 31.0505 26.2499 31.6968 24.7811 31.9877C23.3123 32.2786 21.7946 32.2053 20.3607 31.7742C18.9267 31.343 17.6203 30.5672 16.5555 29.5145C15.4907 28.4617 14.6999 27.1642 14.2524 25.7353C13.805 24.3064 13.7143 22.7896 13.9884 21.3176C14.2625 19.8456 14.8931 18.4631 15.8249 17.2911C16.7567 16.119 17.9615 15.1931 19.3339 14.5942M31.4694 19.4921C31.8364 20.378 32.0615 21.3146 32.1379 22.2675C32.1568 22.5029 32.1662 22.6206 32.1194 22.7266C32.0804 22.8152 32.003 22.899 31.9179 22.945C31.8159 23 31.6886 23 31.4339 23H23.7339C23.4772 23 23.3488 23 23.2508 22.9501C23.1645 22.9061 23.0944 22.836 23.0505 22.7498C23.0005 22.6517 23.0005 22.5234 23.0005 22.2667V14.5667C23.0005 14.312 23.0005 14.1846 23.0556 14.0827C23.1016 13.9975 23.1854 13.9202 23.274 13.8811C23.38 13.8344 23.4977 13.8438 23.7331 13.8627C24.6859 13.9391 25.6225 14.1642 26.5085 14.5311C27.6206 14.9918 28.6311 15.667 29.4823 16.5182C30.3335 17.3694 31.0088 18.3799 31.4694 19.4921Z"
                stroke="#6B929C"
                strokeWidth="1.83563"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default WhyInvestEtf4;
